export default {
  common: {
    login: "Login",
    email: "Email",
    password: "Password",
    error: "Error",
    reset_password: "Reset password",
    or: "Or"
  },
  forms: {
    enter_your_email: "Enter your email",
    login: {
      enter_your_password: "Enter your password",
      login_with_google: "Login with Google",
      continue_with_facebook: "Continue with Facebook",
      having_troubles_logging_in: "Having troubles logging in?",
      go_to_login: "Go to login"
    },
    reset_password: {
      reset_your_password: "Reset Your Password",
      cant_find_user:
        "Sorry, we can't find a user with that email. " +
        "<br>Please contact our customer support if you need further assistance.",
      email_sent:
        "An email to reset your password has been sent! " +
        "<br>Please check your email in the next few minutes.",
      back_to_login: "Back to login",
      try_other_email: "Try other email"
    },
    strong_password: {
      new_password: "New Password",
      retype_password: "Retype password",
      strong_password:
        "Please create a password that is at least 8 characters long " +
        "and contains at least one uppercase letter, one lowercase letter, " +
        "one number, and one special character." +
        "<br><br>Avoid using easy-to-guess patterns, " +
        "such as sequential numbers (e.g., '1234') or common words.",
      set_new_password: "Set new password",
      password_changed_successfully: "Password Changed Successfully",
      wrong_token: "Sorry, passed token is wrong."
    },
    new_password: {
      new_password: "New Password",
      retype_password: "Retype password",
      set_new_password: "Set new password",
      password_changed_successfully: "Password Changed Successfully",
      wrong_token: "Sorry, passed token is wrong."
    }
  },
  errors: {
    emailRequired: "Email is required.",
    passwordRequired: "Password is required.",
    passwordRetypeRequired: "Must retype password.",
    emailInvalidFormat: "Email format is invalid.",
    passwordSame: "Both passwords should be the same.",
    passwordMinLength: "Password should have at least 8 characters.",
    password_length: "Password length should be at least 8 characters.",
    passwordUppercase: "Password should contain at least one uppercase letter.",
    passwordLowercase: "Password should contain at least one lowercase letter.",
    passwordNumber: "Password should contain at least one number.",
    passwordSpecial: "Password should contain at least one special character.",
    response_303: "Wrong token.",
    response_400: "Missing parameters.",
    response_401: "Please enter valid credentials.",
    response_404: "Please enter valid credentials.",
    response_500: "Internal server error. Please contact with administrators.",
    missing_parameters: "Some parameters has been missing."
  },
  meta: {
    curaytor_logo: "Curaytor - Help, Not Hype Copy"
  }
};



// WEBPACK FOOTER //
// ./src/content/i18n/en.js